module.exports = __webpack_public_path__ + "img/case_31.9202612c.png";